import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=1b2459f9&scoped=true"
import script from "./CustomerAddress.vue?vue&type=script&lang=js"
export * from "./CustomerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2459f9",
  null
  
)

export default component.exports